module.exports = __webpack_public_path__ + "media/images/landing_page/dashboard (copy)-7e2bdc106035d9ae809cb823f121341d.webp";